import React, { useState } from 'react';

export default function ThemeSwitcher() {
  const [isLight, setIsLight] = useState(() => {
    // Check initial state from html class
    return document.documentElement.classList.contains('light');
  });

  const toggleTheme = () => {
    setIsLight((prev) => {
      const nextTheme = !prev;
      if (nextTheme) {
        document.documentElement.classList.add('light');
        localStorage.setItem('theme', 'light');
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#eef7fc');
      } else {
        document.documentElement.classList.remove('light');
        localStorage.setItem('theme', 'dark');
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#0a1628');
      }
      return nextTheme;
    });
  };

  return (
    <button
      onClick={toggleTheme}
      type="button"
      aria-label="Toggle color theme"
      className="nexus-theme-toggle p-2 rounded-xl relative overflow-hidden group flex items-center justify-center nexus-transition"
      title={isLight ? 'Switch to Dark Mode (recommended)' : 'Switch to Light Mode'}
    >
      <span className="transform transition-transform duration-500 ease-out group-hover:rotate-[30deg]">
        {isLight ? (
          // Moon icon: indicates dark theme is next
          <svg className="w-5 h-5 text-[var(--brand-cyan)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
        ) : (
          // Sun icon: indicates light theme is next
          <svg className="w-5 h-5 text-[var(--brand-cyan-dark)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m12.728 0l-.707-.707M6.343 6.343l-.707-.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
      </span>
    </button>
  );
}
